package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_12_07_Day_1
import com.veldekar.components.logs.Log_2024_12_07_Day_2
import com.veldekar.components.logs.Log_2024_12_07_Day_3
import com.veldekar.components.logs.Log_2024_12_07_Day_4
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-12-07")
@Composable
public fun Log_2024_12_07(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Ankhegs, get in my tummy!",
        ogTitle = "Ankhegs, get in my tummy!",
        date = LocalDate(2_024, 12, 7),
        aiHint = "Description is a joke",
        ogDescription = "“They” say that Ankheg are the “Lobster of the Land.”",
        ogImage = "images/lobsterBibCat_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration of a cat wearing a lobster bib. The cat is meant to represent Bigglesworth, who is cat-like but looks more like a man than this cartoon cat.",
    ) {
        SessionDayHeader(dayId = "newgrowth-63", dateString = "Newgrowth 63", cardImageSrc = "images/lobsterBibCat.webp", width = 2_467, height = 3_209)
        Log_2024_12_07_Day_1()
        SessionDayHeader(dayId = "newgrowth-64", dateString = "Newgrowth 64")
        Log_2024_12_07_Day_2()
        SessionDayHeader(dayId = "newgrowth-65", dateString = "Newgrowth 65")
        Log_2024_12_07_Day_3()
        SessionDayHeader(dayId = "newgrowth-66", dateString = "Newgrowth 66")
        Log_2024_12_07_Day_4()
        SessionMediaItem(
            image = "images/coveredWagon_small.webp",
            linkImage = "images/coveredWagon.webp",
            description = "A hand-drawn illustration of Joral Deetry's covered wagon on a sandy ground under a bright sun.",
            width = 1_878,
            height = 1_542,
        )
    }
}
